import React from 'react';

// atoms
import Alert from '../../../atoms/icons/alert';
import Title from '../../../atoms/title';
import Text from '../../../atoms/text';
import Button from '../../../atoms/button';

// style
import './style.scss';

export default () => {
  return (
    <>
      <Alert />
      <Title>Ops!</Title>
      <Text>
        Parece que houve um problema ao tentar ativar sua degustação. Por favor
        tente novamente.
      </Text>
      <Button to="/ativacao">Tentar novamente</Button>
    </>
  );
};
